import React from "react"
import { CustomContentProps, SnackbarContent, closeSnackbar } from "notistack"
import StaticSnackbar, { Props as StaticSnackbarProps } from "./StaticSnackbar"

interface Props extends CustomContentProps {
  type?: StaticSnackbarProps["variant"]
  severity?: StaticSnackbarProps["severity"]
  action?: StaticSnackbarProps["action"]
  size?: StaticSnackbarProps["size"]
}

const Snackbar = React.forwardRef<HTMLDivElement, Props>(
  ({ variant, type, size, ...props }, ref) => (
    <SnackbarContent ref={ref}>
      <StaticSnackbar
        {...props}
        size={size}
        variant={type}
        severity={variant === "default" ? "success" : variant}
        persist={false}
        onDismiss={closeSnackbar}
      />
    </SnackbarContent>
  )
)

export default Snackbar
